import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { unFormatUnknownUnit } from '@/common/utils/unFormatters'
import { MaintenanceWorkflowValidationSchema } from '@/features/maintenanceWorkflow/schemas/maintenanceWorkflow.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseCreateMaintenanceWorkflowProps {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useCreateMaintenanceWorkflow = ({ onSuccess, onError }: UseCreateMaintenanceWorkflowProps = {}) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createMaintenanceWorkflow'],
    mutationFn: (form: MaintenanceWorkflowValidationSchema) => {
      return privateAxios.post('/maintenance/workflows', {
        workflow: {
          current_equipment_usage: form.current_equipment_usage ? unFormatUnknownUnit(form.current_equipment_usage) : undefined,
          observations: form.observations,
          solicitation_ids: form.solicitation_ids,
        },
      });
    },
    onSuccess,
    onError,
  })
}
